import { render, staticRenderFns } from "./CompraOportunidade.vue?vue&type=template&id=0ec72ef2"
import script from "./CompraOportunidade.vue?vue&type=script&lang=js"
export * from "./CompraOportunidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports